import { NavLink } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

const SUB_TABS = [
  { id: 'analysis', label: 'Analysis', path: '/events', adminOnly: false },
  { id: 'intelligence', label: 'Intelligence', path: '/events/intelligence', adminOnly: false },
  { id: 'pack-list', label: 'Pack List', path: '/events/pack-list', adminOnly: false },
  { id: 'live', label: 'Live', path: '/events/live', adminOnly: false },
  { id: 'admin', label: 'Event Admin', path: '/events/admin', adminOnly: true },
] as const

export function EventsSubTabs() {
  const role = useAuthStore((s) => s.user?.role)
  return (
    <div role="tablist" aria-label="Events view" className="flex gap-1">
      {SUB_TABS.filter((t) => !t.adminOnly || role === 'admin').map((tab) => (
        <NavLink
          key={tab.id}
          to={tab.path}
          end={tab.path === '/events'}
          data-testid={`events-subtab-${tab.id}`}
          className={({ isActive }) =>
            `h-7 px-3 text-xs border inline-flex items-center ${
              isActive
                ? 'border-[var(--text-primary)] text-[var(--text-primary)] font-semibold'
                : 'border-[var(--line-warm)] text-[var(--ink-2)] hover:border-[var(--ink-2)]'
            }`
          }
          // In-page tabs carry the dark underline; burgundy is reserved for
          // the main navigation (TopTabs) so the two levels stay distinct.
          style={({ isActive }) => ({
            background: 'var(--surface-card)',
            textDecoration: 'none',
            ...(isActive ? { boxShadow: 'inset 0 -2px 0 var(--text-primary)' } : {}),
          })}
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  )
}
